import { render, staticRenderFns } from "./PeoplePage.vue?vue&type=template&id=fa8b2a12"
import script from "./PeoplePage.vue?vue&type=script&lang=js"
export * from "./PeoplePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports